"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledText = void 0;
const react_1 = __importDefault(require("react"));
const defaultStyle = {
    color: "black",
    fontSize: "16px",
    fontWeight: "normal"
};
function StyledText(props) {
    const data = props.data;
    if (Array.isArray(data) === false)
        return react_1.default.createElement("div", null, data);
    return react_1.default.createElement(react_1.default.Fragment, null, data.map((item, index) => {
        if (typeof item === "string")
            return react_1.default.createElement("span", null, item);
        if ("img" in item) {
            let imgStyle = {};
            if (item.style) {
                imgStyle = item.style;
            }
            return react_1.default.createElement("img", { src: item.img, style: imgStyle });
        }
        let itemStyle = item.style;
        if (!item.style) {
            itemStyle = defaultStyle;
        }
        const textColor = itemStyle.color ? itemStyle.color : defaultStyle.color;
        const textSize = itemStyle.fontSize ? itemStyle.fontSize : defaultStyle.fontSize;
        const fontWeight = itemStyle.fontWeight ? itemStyle.fontWeight : defaultStyle.fontWeight;
        return react_1.default.createElement("span", { style: { color: textColor, fontSize: textSize, fontWeight: fontWeight,
                whiteSpace: "pre-line"
            } }, item.text);
    }));
}
exports.StyledText = StyledText;
